// Treasury — section layout.
//
// This file mounts children only. The wallets directory that used to
// live here is now treasury.index.tsx, so the section has the same
// shape as the Revenue and Fees groups next door:
//
//   /treasury                  the wallets directory (index)
//   /treasury/$id              one wallet — balance, history, actions
//   /treasury/transfer         operator credit transfer
//   /treasury/accounts         system accounts, per currency
//   /treasury/payouts          admin payout review queue
//   /treasury/pools            GREEN conversion liquidity
//   /treasury/revenue/*        fee revenue, commissions, distributions
//   /treasury/fees/*           fee policy tooling
//
// Why the split (SM-494 follow-up): a `validateSearch` declared on a
// layout route is inherited by every route beneath it. The wallets list
// declares `?currency=`, and while it lived here that param belonged to
// Payouts, System accounts and the whole Revenue group as well — each of
// which has since grown its own, different `?currency=`. A child could
// only ever NARROW the type it inherited, so a page that typed its own
// as a plain string failed to compile against a union it never
// mentioned. Search params belong to the route that owns them; a layout
// route owns none.
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/treasury")({
  component: Outlet,
});
